<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<h1 class="•-CH-TITLE-8-4-2015 _idGenParaOverride-1" id="_idParaDest-7"><a id="_idTextAnchor006"></a>ACT ONE. 2004:<br/>Annus Notabilis</h1>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ebook_-_test-8.vue?3d53694f